import { useEffect, useMemo, useState } from "react";
import { Button, Modal, Select } from "antd";
import "./dialog.scss";

const RoleDeleteConfirmation = ({
  isOpen,
  onClose,
  onRemove,
  dataSource,
  selectedRowKeys,
}) => {
  const [defaultRole, setDefaultRole] = useState(null);

  useEffect(() => {
    setDefaultRole(null);
  }, [isOpen]);


  const rolesDeletionUsers = useMemo(() => {
    if (!dataSource || !selectedRowKeys) return 0;

    return dataSource.reduce((totalUsers, item) =>
      selectedRowKeys.includes(item._id) ? totalUsers + item.userCount : totalUsers,
      0);
  }, [dataSource, selectedRowKeys]);

  const excludedRoles = useMemo(() => {
    if (!dataSource || !selectedRowKeys) return [];

    return dataSource.map((item) => selectedRowKeys.includes(item._id) ? null : item).filter(_ => _);
  }, [dataSource, selectedRowKeys]);

  const roleName = useMemo(() => {
    if (selectedRowKeys.length !== 1) return selectedRowKeys.length.toString();

    const roleId = selectedRowKeys[0];
    for (const item of dataSource) {
      if (item._id === roleId) {
        return item.name;
      }
    }
  }, [dataSource, selectedRowKeys]);

  const requireDefault = rolesDeletionUsers > 0;

  const plural = selectedRowKeys.length !== 1;
  const usersPlural = rolesDeletionUsers !== 1;

  return (
    <Modal
      title={`Delete Role${plural ? "s" : ""}`}
      open={isOpen}
      onClose={onClose}
      onOk={onRemove}
      onCancel={onClose}
      centered
      footer={
        <div>
          <div className="roles-delete-container">
            {
              requireDefault ?
                `${plural ? "These" : "This"} role${plural ? "s" : ""} ${plural ? "are" : "is"} assigned to ${rolesDeletionUsers} user${usersPlural ? "s" : ""}. Please select a default role before deleting.` :
                `Do you want to delete ${roleName} role${plural ? "s" : ""}?`
            }
            {
              requireDefault &&
              <Select value={defaultRole} onChange={(value) => setDefaultRole(value)} style={{ width: 160, marginTop: 10, marginBottom: 10 }}>
                {excludedRoles.map(item => (
                  <Select.Option key={item._id} value={item._id}>
                    {item.name}
                  </Select.Option>
                ))
                }
              </Select>
            }
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={() => onRemove({ defaultRole, roleIds: selectedRowKeys })} danger disabled={requireDefault && !defaultRole}>
              Delete
            </Button>
          </div>
        </div>
      }
    >
    </Modal>
  );
};

export default RoleDeleteConfirmation;
